/* eslint-disable react/react-in-jsx-scope */
import ReportFeedback from "./components/ReportFeedback.tsx";
import { Toaster } from "./components/ui/toaster";
import "./global.css";
import "./i18n.tsx";
import AppRoutes from "./routes/AppRoutes";
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();
  const isPublicSubmitAccess =
    location.pathname.includes("/submit/user-partner-subscription/")
    || location.pathname.includes("/submit/user-subscription/")
    || location.pathname.includes("/submit/cfp-subscription/")
    || location.pathname.includes("/submit/authentification-cfp/");

  return (
    <main>
      <AppRoutes />
      {!isPublicSubmitAccess && <ReportFeedback />}
      <Toaster />
    </main>
  );
}

export default App;
